import React, { useMemo } from 'react';

import LinkButton from 'components/uiLibrary/LinkButton';
import SpriteIcon from 'components/uiLibrary/SpriteIcon';

import { SUB_COMPONENTS } from 'components/Globals/Analytics/constants';

import useAppContext from 'utils/hooks/useAppContext';
import useDeviceTypeLayouts from 'utils/hooks/useDeviceTypeLayouts';
import useNavigate from 'utils/hooks/useNavigate';
import { getEntityAndTypeFromContributor } from 'utils/productions';

import { ENTITY_TYPES } from 'operabase-router/constants';

import classes from './ProductionPeriod.module.scss';

const ProductionPeriod = ({ production, trackingData = {}, entity }) => {
  const navigate = useNavigate();
  const { isMobile } = useDeviceTypeLayouts();
  const productionLinkProps = navigate.getLinkProps({ entity: production, entityType: ENTITY_TYPES.PRODUCTION });
  const { obRouteContext } = useAppContext();
  const isArtistProPage =
    obRouteContext?.page?.entityType === ENTITY_TYPES.PROFILE && !!obRouteContext.page?.entity?.id;

  const isRedMask = useMemo(() => {
    if (isArtistProPage) {
      const showRedMask =
        production?.showRedMask ||
        production?.contributions?.find(contributor => {
          const { entity: contributorEntity } = getEntityAndTypeFromContributor(contributor);
          return contributorEntity?.id === entity?.id;
        })?.isRedMasked;
      return showRedMask;
    }

    return null;
  }, [production, entity, isArtistProPage]);

  const showRedMaskIcon = (isRedMask && isArtistProPage) || !isArtistProPage;

  const iconElement = (
    <SpriteIcon icon={showRedMaskIcon ? 'red_mask' : 'grey_mask'} size={12} className={classes.icon} />
  );

  return (
    <LinkButton
      variant="text"
      {...productionLinkProps}
      styles={{ root: classes.periode }}
      leftIcon={isMobile ? iconElement : undefined}
      rightIcon={!isMobile ? iconElement : undefined}
      stopPropagation
      isLink
      target="_blank"
      trackingData={{
        ...trackingData,
        subComponent: SUB_COMPONENTS.NAVIGATE_CTA,
        meta: {
          id: production?.id,
        },
      }}
    >
      {production?.periode}
    </LinkButton>
  );
};

export default ProductionPeriod;
